import React, {useMemo, useState} from "react";
import {ListSubheader, MenuItem, TextField} from "@mui/material";
import {SelectField} from "@atttomyx/react-components";
import {arrays, forms} from "@atttomyx/shared-utils";
import {ADD_NEW} from "../../constants";

const TYPE_CATEGORY = "category";
const TYPE_LABEL = "label";

const ConnectionField = (props) => {
    const {categories, label, required, disabled, error, value, onChange} = props;
    const [showCustomType, setShowCustomType] = useState(false);
    const [showCustomCategory, setShowCustomCategory] = useState(false);
    const [category, setCategory] = useState(null);

    const categoriesByLabel = useMemo(() => {
        const ret = {};

        categories.forEach((category) => {
            category.labels.forEach((label) => {
                ret[label] = category.category;
            });
        });

        return ret;
    }, [categories]);

    const categoryTypes = useMemo(() => {
        const types = categories.map((category) => category.category);

        arrays.addTo(types, ADD_NEW);

        return types;
    }, categories);

    const flattened = useMemo(() => {
        const ret = [];

        categories.forEach((category) => {
            arrays.addTo(ret, {
                type: TYPE_CATEGORY,
                value: category.category,
            });

            category.labels.forEach((label) => {
                arrays.addTo(ret, {
                    type: TYPE_LABEL,
                    value: label,
                });
            });
        });

        return ret;
    }, [categories]);

    return <div className="connection-field">
        {showCustomType ?
            <>
                <div className="field">
                    <TextField
                        required={true}
                        label="New connection type"
                        type="text"
                        value={forms.sanitizeValue(value)}
                        onChange={(event) => {
                            const custom = event.target.value;
                            const existing = categoriesByLabel[custom];

                            if (existing) {
                                setCategory(existing);
                                onChange(existing, custom);

                            } else {
                                onChange(category, custom);
                            }
                        }}
                    />
                </div>
                <div className="field">
                    {showCustomCategory ?
                        <TextField
                            required={true}
                            label="New connection category"
                            type="text"
                            value={forms.sanitizeValue(category)}
                            onChange={(event) => {
                                const custom = event.target.value;

                                setCategory(custom);
                                onChange(custom, value);
                            }}
                        /> :
                        <SelectField
                            required={true}
                            label="Connection category"
                            value={category}
                            onChange={(item) => {
                                if (ADD_NEW === item) {
                                    setShowCustomCategory(true);
                                    setCategory(null);
                                    onChange(null, value);

                                } else {
                                    setCategory(item);
                                    onChange(item, value);
                                }
                            }}
                            options={categoryTypes}
                        />}
                </div>
            </> :
            <TextField
                label={label}
                required={required}
                disabled={disabled}
                select={true}
                value={forms.sanitizeValue(value)}
                error={error}
                onChange={(event) => {
                    const label = event.target.value;

                    if (ADD_NEW === label) {
                        setShowCustomType(true);
                        setCategory(null);
                        onChange(null, null);

                    } else {
                        const existing = categoriesByLabel[label];

                        onChange(existing, label);
                    }
                }}
                SelectProps={{
                    multiple: false,
                }}
            >
                {!required ? <MenuItem value="">&nbsp;</MenuItem> : null}
                {flattened.map(item => (
                    item.type === TYPE_CATEGORY
                        ? <ListSubheader key={item.value}>{item.value}</ListSubheader>
                        : <MenuItem key={item.value} value={item.value}>{item.value}</MenuItem>
                ))}
                <ListSubheader>---</ListSubheader>
                <MenuItem value={ADD_NEW}>{ADD_NEW}</MenuItem>
            </TextField>
        }
    </div>
}

export default ConnectionField;
